import { Column } from "@/components/Column";
import { Row } from "@/components/Row";

export const FormSection = ({
  children,
  description,
  title,
}: {
  children: React.ReactElement | React.ReactElement[];
  description: string;
  title: string;
}) => {
  return (
    <Row className="gap-20">
      <Column className="w-[250px] gap-[2px]">
        <p className="text-lg font-semibold text-slate-700">{title}</p>
        <p className="text-sm font-medium text-slate-500">{description}</p>
      </Column>
      <Column className="w-full gap-6">{children}</Column>
    </Row>
  );
};
